import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getImageInfo = normalize.getImageInfo(function (args) {
  return wx.getImageInfo(args);
}, CONTAINER_NAME.WECHAT);
export default getImageInfo;